var map = {
	"./button.svg": "4ed4",
	"./cascader.svg": "a393",
	"./checkbox.svg": "8963",
	"./color.svg": "03ab",
	"./component.svg": "56d6",
	"./date-range.svg": "e6df",
	"./date.svg": "235f",
	"./input.svg": "81d6",
	"./number.svg": "1fce",
	"./password.svg": "2a3d",
	"./radio.svg": "d8dc",
	"./rankA.svg": "64b6",
	"./rankB.svg": "7b9a",
	"./rankC.svg": "4ed8",
	"./rate.svg": "6786",
	"./rich-text.svg": "c630",
	"./row.svg": "c95d",
	"./select.svg": "064a",
	"./slider.svg": "eb1c",
	"./switch.svg": "2384",
	"./table.svg": "47f1",
	"./textarea.svg": "128d",
	"./time-range.svg": "861cb",
	"./time.svg": "3add",
	"./upload.svg": "9d82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ffe";